/** A diagnose run's subject: its scope and the booking it was asked on (the grid's cell and the
 *  run page's field). */
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { SUBJECT_SCOPE_LABELS, type McpDiagnoseRun } from '@/api/mcpDiagnoseRuns';
import { ValueActions } from '@/components/ValueActions/ValueActions';

import { bookingActions } from './mcpDiagnoseRunLinks';

export function SubjectCell({ subject }: { subject: McpDiagnoseRun['subject'] }) {
  return (
    <span>
      {SUBJECT_SCOPE_LABELS[subject.scope] ?? subject.scope}
      {subject.booking_id !== null && (
        <>
          {' · '}
          <ValueActions actions={bookingActions(subject.booking_id)}>
            {/* Navigates by itself (cmd-click opens a tab), never the grid row. */}
            <Link
              component={RouterLink}
              to={`/bookings/${subject.booking_id}`}
              underline="hover"
              onClick={(e) => e.stopPropagation()}
            >
              #{subject.booking_id}
            </Link>
          </ValueActions>
        </>
      )}
    </span>
  );
}
